import {Link, useParams, useNavigate} from 'react-router-dom';
import React, { useContext, useState, useEffect } from 'react';
import {useracc, postApi, putApi, setCookie, follwers} from '../../utils/functions';
import {UserContext, UserProvider} from '../../utils/usercontext';

import Blocks from '../components/bbcode/blocks';

import Col from 'react-bootstrap/Col';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';

import { FaKey } from "react-icons/fa6";
import { FaListAlt } from "react-icons/fa";
import { BsGraphUpArrow, BsCheck2 } from "react-icons/bs";
import { PiVideoFill } from "react-icons/pi";

export default function Radio() {
  const navigate = useNavigate();
  const { radio, code } = useParams();
  // yuo can find all params from here
  const value = useContext(UserContext);

  const [appliaction, setApplication] = useState({});
  useEffect(() => {
    async function retrieveApplication(id) {
      const getUser = await useracc();
      value.setUser( getUser );
      value.setTheme( getUser );

      let params = new URLSearchParams();
      params.append('channel', id);
      const x = await postApi(`/v3/frontend/application`, params);
      if( x.status === 200 ) {
        setApplication(x.data);
        if( x.data.fullname ) {
          let _apply = {...apply};
          _apply.fullname = x.data.fullname;
          setApply(_apply);
        }

      } else {
        navigate("/apply");
      }
    }
    retrieveApplication(radio);
  }, [radio]);


  const [apply, setApply] = useState({
    fullname: '',
    facebook: '',
    djing: 0,
    broadcasting: 0,
    previous: ''
  });

  async function processApplication(event) {
    if( event.preventDefault ) event.preventDefault();
    
    
    let params = new URLSearchParams();
    params.append('service', appliaction.id);
    params.append('fullname', document.getElementById('fullname').value);
    params.append('facebook', document.getElementById('facebook').value);
    let djing = document.getElementById('djing');
    params.append('djing', djing.options[djing.selectedIndex].text);
    let broadcasting = document.getElementById('broadcasting');
    params.append('broadcasting', broadcasting.options[broadcasting.selectedIndex].text);
    params.append('previous', document.getElementById('previous').value);
    await putApi(`/v3/frontend/application`, params);
    let process = {...appliaction};
    process.applied = 1;
    setApplication(process);
    process = null;

  }

  if( value?.user?.user )
  return (
    <main className="main">
      <section id="hero" className="hero hero-small section dark-background">
        <div className="hero-background">
          <img src="/images/bg-14.webp" alt="" data-aos-duration="1000" />
          <div className="overlay"></div>
        </div>
      </section>
      


      <section id="featured-services" className="featured-services section light-background about">

        
        <div className="container section-title mt-3">
          <h2>Apply to join {appliaction.title}</h2>
          <p>Positions are voluntary DJ positions</p>
        </div>

        <div className="container">

          <div className="row">
            <div className="col-lg-6">
              <div className="services-content" data-aos-duration="900">
                <h2>{appliaction.title}</h2>
                {appliaction.description &&
                  <Blocks id={`editor-${appliaction.id}`} blocks={appliaction.description} />
                }
                <div className="stats-container">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="stat-item">
                        <div className="number">{follwers(appliaction.followers)}</div>
                        <div className="label">Followers</div>
                      </div>
                    </div>
                    {/*<div className="col-md-4">
                      <div className="stat-item">
                        <div className="number">450+</div>
                        <div className="label">Projects Completed</div>
                      </div>
                    </div>*/}
                    <div className="col-md-4">
                      <div className="stat-item">
                        <div className="number">{follwers(appliaction.members)}</div>
                        <div className="label">Team Members</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="image-wrapper">
                <img src={`https://cloud.ultrastream.io/images/components/offline.jpg`} alt="Business Services" className="img-fluid main-image" />
                <div className="shape-circle"></div>
                <div className="shape-accent"></div>
                <div className="floating-card">
                  <div className="card-content">
                    {appliaction?.platforms?.filter(elem=>elem.status>0 && elem.website.length>0).map((e, i)=>{
                      return (
                        <a key={i} href={e.website} target="_blank" rel="noreferrer">
                          <div  className="bi bi-award">
                            <img src={`https://cloud.ultrastream.io/images/platforms/${e.platform.toLowerCase()}.png`} />
                          </div>
                        </a>
                      )
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </section>

      <section id="contact" className="contact section">
        <div className="container">
          <div className="contact-main-wrapper">
            

            <div className="contact-content">
              

              <div className="contact-form-container">
                <h3>Join {appliaction.title}</h3>
                <p>Please fill in the following details:</p>

                {value.user.user.id === 1 ?
                  <>You will need to <a href="https://portal.ultrastream.io/">sign in</a> or <a href="https://portal.ultrastream.io/register">register</a> for an account before applying.</>
                :
                  <>
                    {appliaction.applied === -1 &&
                      <p>
                        Positions for this radio station are currently closed. You may contact the teams organisers to find out more.
                      </p>
                    }
                    {(appliaction.applied === 0 || appliaction.applied === 1 ) &&
                      <form className="php-email-form" onSubmit={(e)=>processApplication(e)}>
                        <div className="form-group mt-3">
                          <label htmlFor="fullname" className="form-label p">Full Name :</label>
                          <input type="text" className="form-control" id="fullname" placeholder="Full Name" defaultValue={apply.fullname} required disabled={appliaction.applied === 1} />
                        </div>
                        <div className="form-group mt-3">
                          <label htmlFor="facebook" className="form-label p">Facebook Profile Page:<br /><small>Provide a link to your own facebbok profile page and not to a page or group.</small></label>
                          <input type="text" className="form-control" id="facebook" placeholder="Facebook Profile Page" defaultValue={apply.facebook} required disabled={appliaction.applied === 1} />
                        </div>
                        <div className="form-group mt-3">
                          <label className="form-label ">Please give us an overview of the experience you have in DJing</label>
                          <select className="form-select form-select-sm" id="djing" defaultValue={apply.djind} disabled={appliaction.applied === 1}>
                            <option value="0">No experience DJing</option>
                            <option value="1">Less than 5 years experience</option>
                            <option value="2">More than 5 years experience</option>
                          </select>
                        </div>
                        <div className="form-group mt-3">
                          <label className="form-label p">Please give us an overview of the experience you have in Broadcasting</label>
                          <select className="form-select form-select-sm" id="broadcasting" defaultValue={apply.broadcasting} disabled={appliaction.applied === 1}>
                            <option value="0">No broadcasting experience</option>
                            <option value="1">Less than 5 years experience</option>
                            <option value="2">More than 5 years experience</option>
                          </select>
                        </div>
                        <div className="form-group mt-3">
                          <label htmlFor="previous" className="form-label ">
                            Prvious Mix :<br />
                            <small>Provide a link to where we can obtain your previous mixes. Video is not essential</small>
                          </label>
                          <input type="text" className="form-control" id="previous" placeholder="Previous mix" defaultValue={apply.previous} required disabled={appliaction.applied === 1} />
                        </div>
                        {appliaction.applied === 0 ?
                          <div className="form-submit">
                            <button type="submit">Apply</button>
                          </div>
                        :
                          <p className="mt-3">
                            Thank you for your application to join {appliaction.title} and one of the teams organisers will contact you shortly.
                          </p>
                        }
                        
                      </form>
                    }
                    {appliaction.applied === 2 &&
                      <p>
                        You are already part of this group and do not need to rejoin.
                      </p>
                    }
                    
                  </>
                }
                
              </div>
            </div>
            <div className="contact-content">
              

              <div className="contact-form-container">
                <h3>Get in Touch</h3>
                <p>Please use the follow socials to get in touch with the radio stations organisers before joining:</p>

                
              </div>
            </div>
          </div>
        </div>
      </section>
      
    </main>
  )
}
